import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { useSelector } from "react-redux";
import { getSortTranslation } from "../helper";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const SortByFilter = ({ setSortOption, sortOption }) => {
  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);

  const sortByList = [
    { name: "Low to High", value: "price-low-to-high", title: "Price" },
    { name: "High to Low", value: "price-high-to-low", title: "Price" },
    { name: "A to Z", value: "name-a-to-z", title: "Name" },
    { name: "Z to A", value: "name-z-to-a", title: "Name" },
    { name: "Newest", value: "newest", title: "Date" },
    { name: "Oldest", value: "oldest", title: "Date" },
  ];

  const handleSelectFilter = (nameToDisplay, value) => {
    if (sortOption.value === value) {
      setSortOption({
        filterName: "Sort By",
        filterOptionName: "",
        value: "",
      });
    } else {
      setSortOption({
        filterName: "Sort By",
        filterOptionName:
          nameToDisplay.charAt(0).toUpperCase() + nameToDisplay.slice(1),
        value: value,
      });
    }
  };

  const handleClearFilter = () => {
    setSortOption({
      filterName: "Sort By",
      filterOptionName: "",
      value: "",
    });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "42px 12px 0 12px",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        <span
          style={{
            fontWeight: "bold",
          }}
        >
          {language === "arabic" ? "الترتيب" : "Sort"}
        </span>
        <div
          style={{
            display: "flex",
            flexDirection: language === "arabic" ? "row-reverse" : "row",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              color: themeColor,
              marginRight: language === "arabic" ? 0 : 18,
              marginLeft: language === "arabic" ? 18 : 0,
            }}
            onClick={handleClearFilter}
          >
            {language === "arabic" ? "امسح" : "clear"}
          </span>
          <ImportExportIcon />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#FFFFFF",
          border: "2px solid #DEE2E6",
          paddingBottom: "12px",
        }}
      >
        <div>
          {sortByList.map((item, index) => (
            <div
              onClick={() => handleSelectFilter(item.name, item.value)}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridGap: "10px",
                padding: "0px 0px 0 0px",
                marginTop: 13,
                direction: language === "arabic" ? "rtl" : "ltr",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "26px",
                    width: "6px",
                    backgroundColor:
                      sortOption.value === item.value
                        ? themeColor
                        : "transparent",
                  }}
                ></div>
                <span
                  style={{
                    fontWeight: "bold",
                    marginLeft: language === "arabic" ? 0 : 16,
                    marginRight: language === "arabic" ? 16 : 0,
                  }}
                >
                  {language === "arabic"
                    ? getSortTranslation(item.title)
                    : item.title}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    flex: language === "arabic" ? "" : 0.8,
                  }}
                >
                  {language === "arabic"
                    ? getSortTranslation(item.name)
                    : item.name}
                </span>
                {sortOption.value === item.value && (
                  <FiberManualRecordIcon
                    style={{
                      fontSize: 14,
                      flex: language === "arabic" ? 0.8 : "",
                      color: themeColor,
                    }}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SortByFilter;
